import styled from 'styled-components'
import { spacing, typography, color, fontWeight } from '@conserveit/blocks'

/** Outermost wrapper for the sidebar */
export const Container = styled.aside`
  flex-basis: 20%;
  margin-right: ${spacing.loose};
  min-width: 280px;
`

/** Adds some negative space around each section of the sidebar */
export const Section = styled.div`
  margin-bottom: ${spacing.ultraLoose};
`

/** Subtle titles for each sidebar section */
export const Heading = styled.h3`
  margin-bottom: ${spacing.snug};
  ${typography.title};
  color: ${color.theme.typography.subtle};
`

export const List = styled.ul`
`

/** A button disguised as a Link, used for calling filter changes usually */
export const Link = styled.button.attrs({ type: 'button' })`
  display: inline;
  color: inherit;
  ${typography.displaySmall};
  padding: 0;
  background: transparent;
  font-weight: ${fontWeight.normal};
  pointer-events: ${({ disabled }) => disabled ? 'none' : 'default'};

  em {
    font-style: italic;
  }
`

interface ItemProps {
  isActive?: boolean
}

function getFillColor (props: ItemProps) {
  return props.isActive ? color.theme.typography.ink : color.theme.typography.subdued
}

/**  */
export const ListItem = styled.li<ItemProps>`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.tight};
  color: ${getFillColor};

  &:hover {
    text-decoration: ${props => props.isActive ? 'none' : 'underline'};
  }

  svg {
    margin-right: ${spacing.tight};
    stroke: ${getFillColor};
  }
`
